import classnames from "classnames";
import { type ComponentType, type FunctionComponent, type JSX } from "react";

import style from "./LoadingSpinner.module.scss";

export interface LoadingSpinnerProps {
  component?:
    | keyof JSX.IntrinsicElements
    | ComponentType<{ className?: string }>;
  small?: boolean;
  className?: string;
}

export const LoadingSpinner: FunctionComponent<LoadingSpinnerProps> = ({
  component: Component = "span",
  className,
  small,
}) => (
  <Component
    className={classnames(className, style.spinner, { [style.small]: small })}
  />
);
